import {
    DEFAULT_LOMDA_V3_CONTENT,
    DEFAULT_LOMDA_V3_METADATA,
} from "./constants";
import { LomdaV3Content, LomdaV3Metadata } from "./types";

export const parseLomdaV3Content = (raw: string | null): LomdaV3Content =>
    raw ? (JSON.parse(raw) as LomdaV3Content) : { ...DEFAULT_LOMDA_V3_CONTENT };

export const parseLomdaV3Metadata = (raw: string | null): LomdaV3Metadata =>
    raw
        ? (JSON.parse(raw) as LomdaV3Metadata)
        : { ...DEFAULT_LOMDA_V3_METADATA };
